var _mask, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTabIconMePress = function SvgTabIconMePress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "tab_icon_me_press_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 22v-2.667c0-1.414-.474-2.77-1.318-3.77S17.694 14 16.5 14h-9c-1.193 0-2.338.562-3.182 1.562S3 17.92 3 19.333V22"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 22v-2.667c0-1.414-.474-2.77-1.318-3.77S17.694 14 16.5 14h-9c-1.193 0-2.338.562-3.182 1.562S3 17.92 3 19.333V22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 22a2 2 0 1 0 4 0zm-2.5-8v-2zm-9 0v-2zM3 19.333H1zM1 22a2 2 0 1 0 4 0zm22 0v-2.667h-4V22zm0-2.667c0-1.845-.616-3.67-1.79-5.06l-3.057 2.579c.514.609.847 1.498.847 2.481zm-1.79-5.06C20.029 12.87 18.345 12 16.5 12v4c.543 0 1.148.253 1.653.852zM16.5 12h-9v4h9zm-9 0c-1.844 0-3.528.87-4.71 2.272l3.057 2.58c.505-.6 1.11-.852 1.653-.852zm-4.71 2.272C1.615 15.664 1 17.488 1 19.333h4c0-.983.333-1.872.847-2.481zM1 19.333V22h4v-2.667z",
    mask: "url(#tab_icon_me_press_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  })));
};
export default SvgTabIconMePress;